import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * ALOCAÇÃO DAS DISCIPLINAS NAS TURMAS — migração de Relatórios > Disciplinas / Turmas
 * (`EmissaoRelatorio.aspx?modo=3`).
 *
 * UMA rota: os três agrupamentos (turma, disciplina, professor) são opções da mesma tela, e não
 * itens de menu — o legado também tinha um item só. A permissão é a NOVA (300805099), vizinha da
 * legada 300805000; ver CLAUDE.md, "Permissão de tela nova".
 */
export default [
  {
    description: 'Alocação das Disciplinas nas Turmas',
    path: '/academico/relatorios/alocacaodisciplinasturmas',
    name: 'alocacao-disciplinas-turmas',
    component: () => import('@/views/academico/relatorios/alocacaodisciplinas/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.DISCIPLINASTURMASNOVO_MENU_300805099],
    },
    goesToMenu: true,
  },
];
